<div class="flex flex-col w-full h-full gap-2">
  <!-- Der Header gehört planBIC: die Library blendet ihre eigene Leiste über
       config.toolbar aus (siehe BimViewerService.viewerConfig), sonst stünden
       zwei Kopfzeilen übereinander. Suche und "IFC Öffnen" werden
       deshalb hier angebunden. -->
  <app-page-header [wrap]="true">
    <div class="truncate">IFC-Viewer</div>
    <div class="rounded-lg flex flex-row justify-end items-center gap-4 h-10 ml-auto">
      <div class="w-72">
        <bic-input
          (valueChange)="structureSearchTerm = $event"
          [iconStart]="faSearch"
          placeholder="Suchen nach…"
        ></bic-input>
      </div>
      <bic-button (onClick)="openModelSelection()" [disabled]="!isViewerReady" buttonType="white">
        <fa-icon [icon]="faPlus" iconLeft></fa-icon>
        IFC Öffnen
      </bic-button>
      <bic-button (onClick)="createCoordinationModel()" [disabled]="!isCoordinationView" buttonType="white">
        <fa-icon [icon]="faLayerGroup" iconLeft></fa-icon>
        Koordinationsmodell erstellen
      </bic-button>
    </div>
  </app-page-header>

  <!-- Die Library bringt Modellstruktur, Eigenschaften und BCF-Panel selbst
       mit; das BCF-Panel wird über ihren Viewport-Toolbar-Button geschaltet.
       [routeLayoutSync] bleibt aus, sonst navigiert der Viewer absolut auf
       /viewer bzw. /viewer-bcf und verlässt die Datei-Route. -->
  <lib-bic-bim-viewer
    (ready)="onViewerReady()"
    [config]="viewerConfig"
    [searchTerm]="structureSearchTerm"
    class="flex-1 min-h-0"
  ></lib-bic-bim-viewer>
</div>
